// Brand gradient for the deployment timeline: deployments read left -> right,
// oldest to newest, sweeping through the three Kemaro brand stops.
// Left = site primary blue, middle = a warmer rose, right = the logo orange.
const GRADIENT_STOPS: [number, number, number][] = [
  [17, 143, 243], // #118FF3 primary blue
  [226, 95, 110], // #e25f6e rose
  [217, 146, 110], // #d9926e logo orange
];

const lerp = (a: number, b: number, t: number): number => {
  return Math.round(a + (b - a) * t);
};

const toHex = (rgb: [number, number, number]): string => {
  return '#' + rgb.map((c) => c.toString(16).padStart(2, '0')).join('');
};

export const blockGradientColor = (index: number, total: number): string => {
  if (total <= 1) return toHex(GRADIENT_STOPS[0]);
  const clampedIndex = Math.min(Math.max(index, 0), total - 1);
  const fraction = clampedIndex / (total - 1);
  const scaled = fraction * (GRADIENT_STOPS.length - 1);
  const lower = Math.min(Math.floor(scaled), GRADIENT_STOPS.length - 2);
  const local = scaled - lower;
  const from = GRADIENT_STOPS[lower];
  const to = GRADIENT_STOPS[lower + 1];
  return toHex([
    lerp(from[0], to[0], local),
    lerp(from[1], to[1], local),
    lerp(from[2], to[2], local),
  ]);
};

export const darken = (hex: string, amount = 0.16): string => {
  // Darken the color slightly for things like borders
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const f = (c: number) => Math.round(c * (1 - amount));
  return toHex([f(r), f(g), f(b)]);
};
